'use client';

import ScrollingHeading from "@/components/core/heading/scrolling";
import { useThemeColors } from "@/lib/colors";
import { useCursorEffects } from "@/modules/cursor/useCursorEffects";
import { useRef } from "react";
import Container from "@/components/core/container";
import Section from "@/components/core/section";
import { Project } from "@/models/project";

interface Props {
  project: Project,
}

export default function ProjectCollab({ project, ...props }: Props) {
  
  const container = useRef<HTMLDivElement>(null);
  
  const colors = useThemeColors("tertiary");
  
  useCursorEffects(container, { color: colors.cursor });

  return (
    <Section ref={container} background_color={colors.background}>
      <Container width="fluid" center={true} className="py-8">
        <ScrollingHeading color={colors.text} transform="uppercase" size="4xl" {...props}>{project.client.title} X 328 Studios</ScrollingHeading>
      </Container>
    </Section>
  )
}